import ItineraryTimeline from "../PackageInfo/ItineraryTimeline";
import Header from "../PackageInfo/Header";
import ModalTriggerList from "../CommonUI/ModalTriggerList";
import JoinEventAction from "../CommonUI/JoinEventAction";
import TrekBasicInfo from "../CommonUI/TrekBasicInfo";
import PackageInclusions from "../CommonUI/PackageInclusions";
import ImageCardsWithVerticalView from "../PackageInfo/ImageCardsWithverticalView";

import tob1 from "../../Images/TamhiniOffBeat/tob1.JPG";
import tob2 from "../../Images/TamhiniOffBeat/tob2.JPG";
import tob3 from "../../Images/TamhiniOffBeat/tob3.jpg";
import tob4 from "../../Images/TamhiniOffBeat/tob4.JPG";
import sav1 from "../../Images/SavlyaGhat/sav1.jpg";
import sav2 from "../../Images/SavlyaGhat/sav2.jpg";
import sav3 from "../../Images/SavlyaGhat/sav3.jpg";

const data = [
  {
    day: "Day 1",
    subheading: "Tamhini Off-Beat Trek",
    schedule: [
      { time: "05:00 AM", activity: "Pick-up at Hadapsar." },
      { time: "05:20 AM", activity: "Pick-up at Swargate." },
      { time: "05:40 AM", activity: "Pick-up at Vanaj Metro Station." },
      { time: "05:55 AM", activity: "Pick-up at Wakad Bridge." },
      { time: "06:10 AM", activity: "Pick-up at Hinjwadi." },
      { time: "07:30 AM", activity: "Breakfast on the way." },
      {
        time: "08:30 AM",
        activity: "Reach the base village and enjoy the trek briefing.",
      },
      {
        time: "08:45 AM",
        activity: "Start the lush and hidden Tamhini Off-Beat Trek.",
      },
      {
        time: "01:00 PM",
        activity: "Return to the base village and enjoy lunch.",
      },
      {
        time: "02:00 PM",
        activity: "Depart from the base village and head toward Savlya Ghat.",
      },
      {
        time: "03:00 PM",
        activity: "Reach Savlya Ghat and explore the scenic viewpoints.",
      },
      { time: "05:00 PM", activity: "Start the return journey to Pune." },
      { time: "10:00 PM", activity: "Approx. arrival back in Pune." },
    ],
    meals: ["Breakfast", "Lunch", "Tea"],
    notes: [
      "Tamhini Off-Beat is a hidden gem for trekkers who want a peaceful trail with untouched greenery and fresh monsoon air.",
    ],
    inclusions: [
      "🚌 Pune to Pune Travel by Non-AC Bus",
      "🍽️ Breakfast & Morning Tea",
      "🥘 Delicious Veg & Non-Veg Lunch",
      "☕ Evening Tea",
      "🧭 Experienced Trek Leader & Local Guide",
      "🩺 Basic First Aid & Hydration Support",
      "🏞️ Entry & Local Charges",
    ],
    exclusions: [
      'Any other charges not mentioned in "Inclusions"',
      "Personal snacks, cold drinks, and extra food expenses.",
      "Personal insurance or medical expenses.",
      "Any emergency evacuation charges.",
      "Photography or videography permits (if applicable).",
    ],
    verticalCards: [
      { title: "Hidden Forest Trail", image: tob1 },
      { title: "Misty Valley View", image: tob2 },
      { title: "Monsoon Greenery", image: tob3 },
      { title: "Streamside Walk", image: tob4 },
      { title: "Savlya Ghat Views", image: sav1 },
      { title: "Panoramic Viewpoint", image: sav2 },
      { title: "Serene Landscape", image: sav3 },
    ],
    trekData: [
      {
        name: "Tamhini Off-Beat with Savlya Ghat",
        image: tob1,
        info: "Discover the raw beauty of the Sahyadris with the Tamhini Off-Beat Trek, a hidden trail known for its untouched forests, giant moss-covered rocks, and calm valley views. This route offers a peaceful trekking experience away from the crowds, where mist, monsoon greenery, and fresh mountain air create a memorable adventure. Ideal for those who enjoy nature, photography, and a less-explored path, this trek lets you experience the true essence of the Western Ghats in a quiet and refreshing setting.",
      },
    ],
    faq: [
      {
        question: "What makes Tamhini Off-Beat Trek special?",
        answer:
          "The trail is known for its peaceful ambiance, dense greenery, hidden viewpoints, and beautiful monsoon scenery.",
      },
      {
        question: "Is this trek suitable for beginners?",
        answer:
          "Yes, it is a beginner-friendly to moderate trek, suitable for people with basic fitness and comfortable walking shoes.",
      },
      {
        question: "What should I carry?",
        answer:
          "Carry a backpack, water bottle, rain cover, trekking shoes, extra clothes, and personal medicines.",
      },
      {
        question: "Are meals included?",
        answer: "Yes, breakfast, lunch, and evening tea are included.",
      },
    ],
  },
];

const TamhiniOffBeat = () => {
  return (
    <div className="bg-gray-50 ">
      <Header trekData={data[0].trekData[0]} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <TrekBasicInfo
          trekName="Tamhini Off-Beat Trek"
          location="Tamhini Ghat"
          trekDifficulty="Moderate"
          ageLimit="16 to 36 Years"
        />
        <PackageInclusions />
      </div>
      <ItineraryTimeline itinerary={data} />
      <ImageCardsWithVerticalView verticalCards={data[0].verticalCards} />
      <ModalTriggerList
        inclusions={data[0].inclusions}
        exclusions={data[0].exclusions}
        type="trek"
        faq={data[0].faq}
      />
      <JoinEventAction />
    </div>
  );
};

export default TamhiniOffBeat;
